"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
exports.default = (function () {
    var message = (0, translation_1.getLocalization)('MAINTENANCE');
    if (message === '-' || message === 'MAINTENANCE')
        return null;
    return React.createElement("div", { className: 'maintaenance-banner' }, message);
});
